import React from "react";
import { Button } from "antd";
import PropTypes from "prop-types";

const PrimaryButton = ({ children, ...props }) => {
  let newProps = props;
  newProps.className = `bg-custom_primary text-white border-custom_primary hover:bg-white hover:text-custom_darkgray border-1 hover:border-custom_primary  ${
    newProps.className ? newProps.className : ""
  }`;
  return <Button {...newProps}>{children}</Button>;
};

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrimaryButton;
